var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyfvsdlogowide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 204.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M524.77,70.13v18.11c0,1.29-1.05,2.34-2.34,2.34h-31.32c-1.29,0-2.34,1.05-2.34,2.34v8.02c0,1.29,1.05,2.34,2.34,2.34h21.22c1.29,0,2.34,1.05,2.34,2.34v16.95c0,1.29-1.05,2.34-2.34,2.34h-21.22c-1.29,0-2.34,1.05-2.34,2.34v29.89c0,1.29-1.05,2.34-2.34,2.34h-24.07c-1.29,0-2.34-1.05-2.34-2.34v-86.99c0-1.29,1.05-2.34,2.34-2.34h60.06c1.29,0,2.34,1.05,2.34,2.34Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.75,70.88l-29.24,86.99c-.32.95-1.21,1.59-2.21,1.59h-33.8c-1,0-1.89-.64-2.21-1.59l-29.24-86.99c-.51-1.51.62-3.08,2.21-3.08h25.57c1.03,0,1.94.68,2.24,1.66l16.16,53.89c.67,2.22,3.81,2.22,4.48,0l16.04-53.89c.29-.99,1.21-1.67,2.24-1.67h25.56c1.6,0,2.72,1.57,2.21,3.08Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642,152.66c-6.48-4.67-10.26-11.32-11.34-19.95-.18-1.4.92-2.64,2.33-2.64h25.91c1.11,0,2.11.76,2.33,1.85.79,4.03,3.04,6.05,6.74,6.05,1.55,0,2.87-.37,3.95-1.1,1.08-.73,1.62-1.88,1.62-3.43,0-2.16-1.17-3.9-3.5-5.24-2.33-1.34-5.95-2.87-10.87-4.6-5.87-2.07-10.72-4.1-14.56-6.08-3.84-1.98-7.14-4.88-9.9-8.67-2.76-3.8-4.1-8.67-4.01-14.63,0-5.96,1.53-11.02,4.6-15.21,3.06-4.19,7.25-7.36,12.56-9.51,5.31-2.16,11.28-3.24,17.93-3.24,11.22,0,20.13,2.59,26.73,7.77,5.99,4.69,9.4,11.13,10.24,19.3.14,1.38-.95,2.58-2.33,2.58h-26.32c-1.11,0-2.1-.78-2.29-1.87-.28-1.63-.87-2.87-1.76-3.7-1.21-1.12-2.68-1.68-4.4-1.68-1.21,0-2.2.41-2.98,1.23-.78.82-1.17,1.96-1.17,3.43,0,2.07,1.14,3.78,3.43,5.11,2.29,1.34,5.93,2.96,10.94,4.85,5.78,2.16,10.55,4.23,14.31,6.21,3.75,1.99,7.01,4.75,9.77,8.29,2.76,3.54,4.14,7.98,4.14,13.33,0,5.61-1.38,10.64-4.14,15.08-2.76,4.45-6.78,7.92-12.04,10.42-5.26,2.5-11.52,3.75-18.77,3.75-10.96,0-20-2.57-27.12-7.7Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.54,73.62c7.2,3.88,12.75,9.28,16.64,16.18,3.88,6.91,5.83,14.76,5.83,23.56s-1.94,16.57-5.83,23.56c-3.88,6.99-9.43,12.49-16.64,16.51-7.21,4.01-15.6,6.02-25.18,6.02h-35.85c-1.29,0-2.34-1.05-2.34-2.34v-86.99c0-1.29,1.05-2.34,2.34-2.34h35.85c9.58,0,17.97,1.94,25.18,5.83ZM765.18,128.51c3.8-3.54,5.7-8.59,5.7-15.15s-1.9-11.61-5.7-15.15c-3.8-3.54-8.93-5.31-15.41-5.31h-4.53c-1.29,0-2.34,1.05-2.34,2.34v36.24c0,1.29,1.05,2.34,2.34,2.34h4.53c6.47,0,11.61-1.77,15.41-5.31Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.14,108.93v49.02c0,.83-.67,1.5-1.5,1.5h-7.43c-.83,0-1.5-.67-1.5-1.5v-24.75c0-1.64-2.26-2.09-2.89-.57l-10.67,25.89c-.23.56-.78.93-1.39.93h-5.89c-.61,0-1.15-.37-1.39-.93l-10.74-25.94c-.63-1.52-2.89-1.07-2.89.57v24.79c0,.83-.67,1.5-1.5,1.5h-7.43c-.83,0-1.5-.67-1.5-1.5v-49.02c0-.83.67-1.5,1.5-1.5h9.36c.6,0,1.14.36,1.38.91l14.78,34.55c.52,1.21,2.24,1.21,2.76,0l14.78-34.54c.24-.55.78-.91,1.38-.91h9.28c.83,0,1.5.67,1.5,1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.65,109.62l-16.28,31.39c-.11.21-.17.45-.17.69v16.24c0,.83-.67,1.5-1.5,1.5h-7.43c-.83,0-1.5-.67-1.5-1.5v-16.24c0-.24-.06-.48-.17-.69l-16.35-31.39c-.52-1,.2-2.19,1.33-2.19h8.35c.58,0,1.11.34,1.36.86l9.41,20.02c.54,1.15,2.18,1.15,2.72,0l9.35-20.01c.25-.53.78-.87,1.36-.87h8.2c1.13,0,1.85,1.19,1.33,2.19Z",
    fill: "#000",
    strokeWidth: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "k0ajHK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.53,64.64c.05,2.81-1.52,4.78-4.83,6.06-42.7,16.45-85.4,32.9-128.1,49.35-6.59,2.53-13.22,4.98-19.76,7.63-5.8,2.35-11.42,2.24-17.25,0-43.38-16.76-86.79-33.45-130.19-50.17-2.49-.96-2.49-.95-2.49,1.63v26.93c0,6.72.01,13.44,0,20.16,0,2.48-2.02,4.49-4.5,4.49h0c-2.48,0-4.5-2.01-4.5-4.49-.02-16.98-.03-33.96.03-50.94,0-1.7-.44-2.61-2.13-3.05-1.43-.37-2.8-1.03-4.19-1.57C1.43,69.41-.02,67.53,0,64.67c.03-2.8,1.41-4.6,4.54-5.81,11.59-4.48,23.18-8.95,34.78-13.41C77.34,30.8,115.35,16.17,153.37,1.52c5.25-2.02,10.44-2.03,15.7,0,49.68,19.14,99.35,38.26,149.03,57.39,2.85,1.09,4.38,3.11,4.43,5.74Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.41,105.4v-1.83c-1.06-.06-1.83.42-2.63.73-27.24,10.48-54.48,20.97-81.72,31.48-6.98,2.69-14.7,2.69-21.67,0-27.87-10.74-55.75-21.46-83.61-32.23-1.67-.64-2.12-.52-2.11,1.41.07,16.26.06,41.33.02,57.59,0,1.57.4,2.12,2.08,2.05,7.44-.33,14.84.22,22.13,1.6,24.57,4.64,44.94,15.89,61.15,33.64,1.35,1.48,2.99,2.64,4.8,3.42,1.81.79,3.77,1.2,5.78,1.2,4.01,0,7.85-1.64,10.56-4.6,21.6-23.58,49.18-35.36,82.72-35.25,1.99,0,2.54-.45,2.53-2.43-.07-15.99-.04-40.79-.04-56.78ZM174.46,162.65c-.21.24-.45.22-.58.2h-.04c-2.39-.04-5.17-.05-7.96.28-1.2.15-2.6.37-3.97.9-.85.34-1.54.86-2.13,1.61-1.06,1.35-.98,3.08.17,4.03,1,.82,2.04.94,3.26.38,1.49-.68,2.83-1.13,4.08-1.38.65-.13,1.47-.29,2.21.11.17.09.34.19.45.41.2.43.56.69,1.01.93.02,0,.04.02.07.04.49.22.49.49.43.68-.11.39-.43.41-.71.39h-.68c-.44,0-.9,0-1.36.04-.49.04-.83-.2-1.05-.39-.04-.04-.06-.07-.1-.1l-.16-.16-.08.21s-.04.08-.07.12c-.13.17-.32.18-.7.2-1.15.05-2.15.34-3.1.9-.71.42-1.31,1.01-1.76,1.75-.3.49-.33,1.02-.34,1.62v.48c0,.41.02.85-.04,1.29-.24,2.04-1.12,3.36-2.7,4.05-1.35.59-2.84.94-4.71,1.13h-.09c-.07.02-.15.03-.24.03-.2,0-.38-.06-.53-.18l-.37-.29.43-.18c.16-.06.31-.12.47-.19l.08-.04c.36-.14.72-.29,1.08-.44.89-.39,1.82-.82,2.64-1.53.97-.85,1.44-1.88,1.42-3.17-.02-1.31-.42-2.49-.86-3.56-.54-1.32-1.1-2.69-1.34-4.19-.13-.86-.12-1.66.04-2.4.32-1.45,1.19-2.52,2.66-3.29,1.21-.63,2.58-1.03,4.2-1.24,3.41-.43,6.73-.11,9.53.26l.23.03c.34.04.7.09,1.06.2l.4.12-.27.32Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 7.19,
    y: 131.68,
    width: 2.2,
    height: 35.2,
    rx: 1.1,
    ry: 1.1,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.79,
    y: 131.68,
    width: 2.2,
    height: 35.2,
    rx: 1.1,
    ry: 1.1,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.38,
    y: 131.68,
    width: 2.2,
    height: 35.2,
    rx: 1.1,
    ry: 1.1,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.97,
    y: 131.68,
    width: 2.2,
    height: 35.2,
    rx: 1.1,
    ry: 1.1,
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.56,
    y: 131.68,
    width: 2.2,
    height: 35.2,
    rx: 1.1,
    ry: 1.1,
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyfvsdlogowide);
export default __webpack_public_path__ + "static/media/my fvsd logo wide.84cab2d2810c0a4022c4c8055eef99c0.svg";
export { ForwardRef as ReactComponent };